<template>
  <DxPopup
    :visible.sync="previewVisible"
    :drag-enabled="false"
    :hide-on-outside-click="true"
    :show-title="true"
    :title="'Image Preview 1'"
    :width="650"
    :height="610"
    :showCloseButton="false"
    @hidden="popupHidden"
    :fullScreen="false"
    ref="gc-popup"
    :wrapperAttr="{ class: 'css-v2 gc-popup gc-popup-image-preview' }"
  >
    <div class="css-v2 gc-popup-form">
      <img
        id="imagePreview"
        :src="this.previewImageSource"
        alt="Company Logo"
        height="500"
        width="520"
      />
    </div>

    <div class="footer" v-bind:class="'multi-btn'">
      <DxButton
        v-if="saveButtonConfig"
        :text="saveButtonConfig.text"
        type="success"
        styling-mode="contained"
        @click="saveButtonConfig.clickCallback"
        :disabled="saveButtonConfig.disabled"
      />
      <DxButton
        v-if="removeButtonConfig && allowRemove"
        :text="'Remove'"
        type="danger"
        styling-mode="contained"
        @click="onRemoveClick"
        :disabled="removeButtonConfig.disabled"
      />
      <DxButton
        :text="'back'"
        type="default"
        styling-mode="contained"
        @click="popupHidden"
      />
    </div>
  </DxPopup>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";

export default {
  mixins: [RouteMixin],
  components: {},
  data() {
    return {};
  },
  props: {
    dataModel: {
      type: Object,
      default: () => {},
    },
    previewVisible: {
      type: Boolean,
      default: false,
    },
    onBackButtonClick: {
      type: Function,
      default: () => {},
    },
    allowDownload: {
      type: Boolean,
      default: false,
    },
    allowRemove: {
      type: Boolean,
      default: false,
    },
    onRemoveImage: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    previewImageSource() {
      return `${this.dataModel.PreviewImageSrc}`;
    },
    saveButtonConfig() {
      if (!this.allowDownload) {
        return undefined;
      } else
        return {
          text: "Download",
          type: "default",
          clickCallback: async () => {
            var blobUrl = this.dataModel.DownloadApiUrl;
            Object.assign(document.createElement("a"), {
              target: "_blank",
              href: blobUrl,
            }).click();
          },
        };
    },
    removeButtonConfig() {
      return {
        text: "Remove",
        type: "danger",
      };
    },
  },

  methods: {
    async onRemoveClick() {
      let confirmDelete = await this.$confirm(
        "Are you sure you wants to remove this image?",
        "Remove Image"
      );

      if (confirmDelete) {
        this.onRemoveImage(this.dataModel.id);
        this.popupHidden();
      }
    },
    popupHidden() {
      this.onBackButtonClick();
    },
  },
};
</script>

<style lang="scss">
.gc-popup-image-preview {
  #imagePreview {
    margin: auto;
    display: block;
  }
  .footer {
    padding-top: 10px;
    bottom: 0;
    height: 45px;
    text-align: right;
  }
  .footer .save-btn {
    margin-right: 10px;
  }
  .custom-title {
    padding-top: 25px;
    padding-bottom: 25px;
  }

  .title-primary {
    font-size: 20px;
    font-weight: 500;
  }

  .title-secondary {
    padding-left: 8px;
    font-size: 16px;
    color: #957f7f;
  }

  .gc-full-screen-popup {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .footer.multi-btn {
    display: flex;
    flex-direction: row;

    .dx-button {
      display: flex;
      justify-content: center;
      flex-grow: 1;
      margin-right: 5px;
    }

    .dx-button:last-child {
      margin-right: 0px;
    }
  }

  .footer.gc-data-grid {
    justify-content: flex-end !important;
    .dx-button {
      flex-grow: unset !important;
    }
  }

  .dx-popup-fullscreen {
    .dx-toolbar {
      background-color: #03a9f4;
      .dx-item-content.dx-toolbar-item-content {
        color: white !important;
      }
    }
  }
}
</style>
